import { ActionButtons } from '../components/ActionButtons';
import { Header } from '../components/Header';
import { InputPanel } from '../components/InputPanel';
import { PreparationCards } from '../components/PreparationCards';
import { StatusBanner } from '../components/StatusBanner';
import { usePreparation } from '../hooks/usePreparation';

export const HomePage = () => {
  const {
    producerProfile,
    setProducerProfile,
    culture,
    setCulture,
    scenario,
    setScenario,
    result,
    loading,
    error,
    notice,
    generate,
    clear,
    exportPdf,
    canExport
  } = usePreparation();

  return (
    <main className="page-shell">
      <div className="page-shell__bg page-shell__bg--top" />
      <div className="page-shell__bg page-shell__bg--bottom" />

      <div className="container">
        <Header />

        <InputPanel
          producerProfile={producerProfile}
          onProducerProfileChange={setProducerProfile}
          culture={culture}
          onCultureChange={setCulture}
          value={scenario}
          onChange={setScenario}
        />

        <ActionButtons
          loading={loading}
          canExport={canExport}
          onGenerate={generate}
          onClear={clear}
          onExportPdf={exportPdf}
        />

        {loading && (
          <StatusBanner
            tone="loading"
            title="Preparando sua ficha estratégica"
            message="Estamos estruturando OPC, SPIN, EPA e Senoide com foco em resultado de negócio e adaptação ao perfil comportamental do produtor."
          />
        )}

        {!loading && error && <StatusBanner tone="error" title="Não foi possível gerar agora" message={error} />}

        {!loading && notice && <StatusBanner tone="success" title="Atualização" message={notice} />}

        {!loading && result && <PreparationCards result={result} />}

        <footer className="site-footer">
          © 2026 Paixão por Vendas, CVale e José Ricardo Noronha®
          <br />
          Inteligência aplicada à Venda de Valor no Agro | Todos os direitos reservados.
        </footer>
      </div>
    </main>
  );
};
